// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FontSizeOutlinedSvg from "@fishx/icons-svg/es/asn/FontSizeOutlined";
import FishxIcon from '../components/FishxIcon';

var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FontSizeOutlinedSvg
  }));
};

FontSizeOutlined.displayName = 'FontSizeOutlined';
export default React.forwardRef(FontSizeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FontSizeOutlined.js
// module id = 2820
// module chunks = 0